import { sortedUniqBy } from 'lodash'

export function getFormattedAdmins(admins) {
  const formattedAdmins = [{ key: '', text: '', value: '' }]
  admins.toList().forEach((admin) => {
    formattedAdmins.push({ key: admin.id, text: admin.fullname, value: admin.fullname })
  })
  return sortedUniqBy(formattedAdmins, 'key')
}
